import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapNotificationSettingsDataFromServer } from "mappers";
import { notificationSettingsService } from "services";
import { uiActions } from "store";
import { ErrorResponse, NotificationSettingsDtoType } from "types";

type GetNotificationSettingsProps = {
	userId: string;
};

const useGetNotificationSettingsByUserIdQuery = ({
	userId,
}: GetNotificationSettingsProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["notificationSettingsData", userId],
		() =>
			notificationSettingsService.getNotificationSettings({
				userId,
			}),
		{
			select: (data: NotificationSettingsDtoType) => {
				return mapNotificationSettingsDataFromServer(data);
			},
			onError(error: ErrorResponse) {
				if (error.status !== 404) {
					dispatch(
						uiActions.showErrorNotification({
							title: getErrorMessage(error),
						}),
					);
				}
			},
			enabled: !!userId,
			retry: false,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetNotificationSettingsByUserIdQuery;
